import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { IAuthentication, IStoreService } from '../../../services';
import { StoreElement } from '../../../stateManagement';

class TicketingKanbanStateController implements angular.IComponentController, angular.IOnInit, angular.IOnDestroy {
    authentication: IAuthentication;
    isLoading: boolean;
    loadingMessage: string;

    private _unsubscribe: () => void;
    //TODO add all bindings

    static $inject = ['storeService'];
    constructor(private _storeService: IStoreService) {
    }

    $onInit() {
        this._unsubscribe = this._storeService.register(
            store => this.authentication = store.authentication.value,
            [StoreElement.Authentication]
        );
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }
}

export const wtTicketingKanbanState: ComponentDefinition = {
    componentId: 'wtTicketingKanbanState',
    controller: TicketingKanbanStateController,
    template: require('./ticketingKanbanState.component.html'),
    controllerAs: 'vm',
    bindings: {
        ticketViewModelList: '<',
        ticketStatusList: '<',
        users: '<',
        selectedTicketViewModel: '=?',
        originalTicketViewModel: '=?',
        saveTicket: '&?',
        isLoading: '<',
        message: '<'
    }
};